import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// override the default styles
import '@hex/calculators-shared/styles/sitecoreOverride.css';
import { setupI18n } from './i18next';

async function setupApp() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupApp);
    return;
  }

  const rootEN = document.getElementById('rootEN') as Element | DocumentFragment;

  if (rootEN) {
    await setupI18n('en');
    const root = createRoot(document.getElementById('rootEN') as Element | DocumentFragment);
    root.render(
      <React.StrictMode>
        <App locale={'en-EN'} />
      </React.StrictMode>,
    );
  } else {
    await setupI18n('fi');
    const root = createRoot(document.getElementById('root') as Element | DocumentFragment);
    root.render(
      <React.StrictMode>
        <App locale={'fi-FI'} />
      </React.StrictMode>,
    );
  }
}

setupApp();
